<template>
  <div class="back1">
    <div class="header">
      <el-col :span="8" class="header-left">
        {{ companyName }}
      </el-col>
      <el-col :span="8"
              class="header-center">易维迅轨道交通集成管理平台设备运维服务平台软件V1.0</el-col>
      <el-col :span="8" class="header-right">
        <span>{{ curentTime }}</span><br /><br />
        <div class="header-op">
          <el-link type="primary" :underline="false" title="返回" @click="goback"><i
              class="el-icon-arrow-left"></i>返回</el-link>
        </div>
      </el-col>
    </div>
    <div class="router">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dashboardmain',
  data () {
    return {
      curentTime: '',
      companyName: this.$store.getUser().companyName
    }
  },

  methods: {

    init () {

    },


    goback () {
      history.back(-1)
    },

    getCurentTime () {
      var now = new Date();
      var year = now.getFullYear();
      var month = now.getMonth() + 1;
      var day = now.getDate();
      var hh = now.getHours();
      var mm = now.getMinutes();
      var ss = now.getSeconds();
      var clock = year + "-";
      if (month < 10)
        clock += "0";
      clock += month + "-";
      if (day < 10) clock += "0";
      clock += day + " ";
      if (hh < 10) clock += "0";
      clock += hh + ":";
      if (mm < 10) clock += '0';
      clock += mm + ":";
      if (ss < 10) clock += '0';
      clock += ss;

      return (clock);
    }
  },
  mounted () {

    setInterval(() => {
      this.curentTime = this.getCurentTime()
    }, 1000)

    this.init()
  },
}
</script>

<style scoped>
.header {
  width: 100%;
  height: 86px;
  background: url(../../assets/imgs/dashboard/header1888x86.png) no-repeat;
  background-size: 100% 100%;
}

.header-center {
  color: #59f2ff;
  text-align: center;
  padding-top: 12px;
  font-size: 24px;
  letter-spacing: 8px;
}

.header-right {
  color: #59f2ff;
  text-align: right;
  padding-right: 36px;
  padding-top: 15px;
  font-size: 14px;
  letter-spacing: 2px;
}

.header-left {
  color: #59f2ff;
  padding-left: 36px;
  padding-top: 15px;
  font-size: 14px;
  letter-spacing: 2px;
}

.header-op {
  margin-right: -32px;
}

.content {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 0px;
  padding-bottom: 0px;
  height: 100vh;
  background: url(../../assets/imgs/dashboard/back3.png) no-repeat;
  background-size: 100% 100%;
}

.router {
  height: calc(100vh - 86px);
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
